import * as Types from '../types-api.generated';

import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiHasWorldNotificationsVariables = Types.Exact<{
  publicKey: Types.Scalars['String'];
  filterWorldId?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type ApiHasWorldNotifications = { hasWorldNotifications: boolean };



export const ApiHasWorldNotificationsDocument = /*#__PURE__*/ `
    query HasWorldNotifications($publicKey: String!, $filterWorldId: Int) {
  hasWorldNotifications: curatorHasExhibitionNotifications(
    accountAddress: $publicKey
    filterExhibitionId: $filterWorldId
  )
}
    `;

export const useHasWorldNotifications = <
      TData = ApiHasWorldNotifications,
      TError = ClientError
    >(
      variables: ApiHasWorldNotificationsVariables,
      options?: Omit<UseQueryOptions<ApiHasWorldNotifications, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiHasWorldNotifications, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiHasWorldNotifications, TError, TData>(
      {
    queryKey: ['HasWorldNotifications', variables],
    queryFn: apiFetcher<ApiHasWorldNotifications, ApiHasWorldNotificationsVariables>(ApiHasWorldNotificationsDocument, variables),
    ...options
  }
    )};

useHasWorldNotifications.getKey = (variables: ApiHasWorldNotificationsVariables) => ['HasWorldNotifications', variables];

export const useInfiniteHasWorldNotifications = <
      TData = InfiniteData<ApiHasWorldNotifications>,
      TError = ClientError
    >(
      variables: ApiHasWorldNotificationsVariables,
      options: Omit<UseInfiniteQueryOptions<ApiHasWorldNotifications, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiHasWorldNotifications, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApiHasWorldNotifications, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['HasWorldNotifications.infinite', variables],
      queryFn: (metaData) => apiFetcher<ApiHasWorldNotifications, ApiHasWorldNotificationsVariables>(ApiHasWorldNotificationsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteHasWorldNotifications.getKey = (variables: ApiHasWorldNotificationsVariables) => ['HasWorldNotifications.infinite', variables];


useHasWorldNotifications.fetcher = (variables: ApiHasWorldNotificationsVariables, options?: RequestInit['headers']) => apiFetcher<ApiHasWorldNotifications, ApiHasWorldNotificationsVariables>(ApiHasWorldNotificationsDocument, variables, options);
